import { fromJS } from "immutable";
import moment from "moment";
import { GET_ROOMS, GET_ROOMS_PRICES,UPDATE_PRICE } from "../actions/constants";

const initialTodos = {
	rooms: [],
	room: {},
	prices: [],
	contador: 0,
};

const rooms = (state = initialTodos, action) => {
	var newState = Object.assign({}, state);
	const datos = fromJS(newState);

	switch (action.type) {
		case GET_ROOMS:
			const rooms = action.payload.map((r) => {
				r.prices = JSON.parse(r.prices);
				//console.log(r);
				return r;
			});
			const roomsNew = datos.updateIn(["rooms"], (value) => rooms);
			var countNew = roomsNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();
		case GET_ROOMS_PRICES:
			const pricesNew = datos.updateIn(["prices"], (value) => action.payload);
			var countNew = pricesNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_PRICE:
			var index = datos.get("prices").findIndex((item) => item.get("id") == action.datos_send.id);
			var data_temp = Object.assign({}, state.prices[index]);
			data_temp[action.datos_send.campo]=action.datos_send.valor
			const precioUpNew = datos.updateIn(["prices",index], (value) => data_temp);
			var countNew = precioUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		default:
			return state;
	}
};

export default rooms;
